import Vue from 'vue';
import 'core-js/stable';
import Layout from './layout/index.vue';
import router from './router';
import store from './store';
import { getCss } from '@/common/utils/get-css';
import { getScript } from '@/common/utils/get-script';
import 'amfe-flexible';
import '@/common/style/base.less';
import '@/common/style/reset.less';
import IconFont from '@/common/components/base/IconFont.vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { ignoreErrors } from './common/ignore/sentryError';
import { _get, _post, _put, _del } from '@/common/request/index';
import './filters/index'; // 注册全局过滤器
// 注册全局指令
require('./directives/index');
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
// 注册事件机制
import eventLib from '@/common/utils/document-event';
window.$_EventLib = eventLib;
Vue.config.productionTip = false;
Vue.prototype.$post = _post;
Vue.prototype.$get = _get;
Vue.prototype.$del = _del;
Vue.prototype.$put = _put;
Vue.prototype.$getScript = getScript;
Vue.prototype.$getCss = getCss;
import { Loading, Hint, MessageBox, Icon, Button, ImagePreview } from '@lhb/ui';
import { aMapServiceHost } from './common/enums/libs-map';
import { getCookie } from '@/common/utils/tools';
import { makeUseOfTokenGetData } from './common/utils/ways';
import { scrollCacheDirective } from './directives/ScrollCache';
Vue.use(Loading).use(Hint).use(MessageBox).use(ImagePreview);
Vue.directive('scroll-cache', scrollCacheDirective);
Vue.component('LIcon', Icon);
Vue.component('LButton', Button);
Vue.component('IconFont', IconFont);
if ((process.env.npm_config_env === 'pe' || process.env.npm_config_env === 'se') && process.env.VUE_APP_SENTRY_DSN) {
    if (process.env.CLOSE_SENTRY !== 'yes') { // 定制化项目打包时入参，可以停掉sentry
        Sentry.init({
            Vue: Vue,
            dsn: process.env.VUE_APP_SENTRY_DSN,
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                    tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
                }),
            ],
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
            // 忽略无意义的错误
            ignoreErrors: ignoreErrors,
            beforeSend: function (event) {
                // console.log(`event`, event);
                // console.log(`hint`, hint);
                var tenantId = getCookie('TENANT_ID');
                var employeeId = getCookie('EMPLOYEE_ID');
                // flow_token则是各种来源(原生桥接获取后写入、不同项目跳转)
                var user = getCookie('storeToken');
                if (event && event.extra) {
                    event.extra.userInfo = {
                        tenantId: tenantId,
                        employeeId: employeeId,
                        // 上报的是token，这里不用token是因为sentry把token当成了关键词，会把一切包含于token的转换为不可见的字符
                        user: user,
                        des: '为方便前端快速排查问题，额外上报的信息',
                    };
                }
                return event;
                // return null 会将此次上报丢弃
            }
        });
    }
}
// 本地测试完成后，记得通过NODE_ENV判断将 本地启动环境屏蔽
if (process.env.NODE_ENV !== 'development') {
    makeUseOfTokenGetData();
    window.LHBbigdata.init({
        isSpa: true,
        cha_type: 'Location',
        // 在cookie或者localStorage里抓取对应的参数放入到外层数据里
        // extendOuterConfig: ['token', 'user_id'],
        extendOuterConfig: [
            // 要求不上报token，说不安全
            // {
            //   key: 'token',
            //   target: 'storeToken'
            // },
            // 根据抓取的目标参数命名不同，上报数据等同于上面
            {
                key: 'user_id',
                target: 'EMPLOYEE_ID'
            }, {
                key: 'tenant_id',
                target: 'TENANT_ID'
            }
            // {
            //   key: 'trace_id',
            //   target: 'trace_id'
            // }
        ],
        // 在cookie或者localStorage里抓取对应的参数放入到msg数据里
        si: 'h5',
        sendFunc: function (params, config) {
            try {
                window.LHBbigdata.xhrTool.send(process.env.BIGDATA_URL || (process.env.npm_config_env === 'pe' ? config.logPathPro : config.logPathPre), params);
            }
            catch (err) { }
        }
    });
}
// https://lbs.amap.com/api/javascript-api-v2/guide/abc/load
window._AMapSecurityConfig = {
    serviceHost: aMapServiceHost,
};
new Vue({
    router: router,
    store: store,
    render: function (h) { return h(Layout); },
}).$mount('#app');
